enum ItemsAndGroupsView {
  ITEMS = 'items',
  GROUPS = 'groups',
}

export default ItemsAndGroupsView;
